/* France-Électronique — JavaScript minimal (amélioration progressive, aucune dépendance). */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* Menu mobile & recherche : fermeture (Échap, clic extérieur, bouton) */
  $$('[data-drawer], [data-search]').forEach(function (d) {
    d.addEventListener('toggle', function () {
      document.documentElement.style.overflow = d.open && d.hasAttribute('data-drawer') ? 'hidden' : '';
      if (d.open && d.hasAttribute('data-search')) {
        var input = $('input[type="search"]', d);
        if (input) input.focus();
      }
    });
  });
  $$('[data-drawer-close]').forEach(function (b) {
    b.addEventListener('click', function () { b.closest('details').open = false; });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('details[open][data-drawer], details[open][data-search], details[open][data-filters]').forEach(function (d) {
      d.open = false;
      var s = $('summary', d); if (s) s.focus();
    });
  });
  document.addEventListener('click', function (e) {
    $$('details[open][data-search], details[open][data-filters]').forEach(function (d) {
      if (!d.contains(e.target)) d.open = false;
    });
    var drawer = $('details[open][data-drawer]');
    if (drawer && !$('.drawer__panel', drawer).contains(e.target) && !$('summary', drawer).contains(e.target)) drawer.open = false;
  });

  /* Galerie produit */
  var gallery = $('[data-gallery]');
  if (gallery) {
    $$('[data-thumb]', gallery).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = btn.getAttribute('data-thumb');
        $$('[data-slide]', gallery).forEach(function (s) {
          var on = s.getAttribute('data-slide') === i;
          s.hidden = !on; s.classList.toggle('is-active', on);
        });
        $$('[data-thumb]', gallery).forEach(function (t) {
          var on = t === btn;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
      });
    });
  }

  /* Boutons de quantité */
  $$('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = $('input', btn.parentNode);
      var min = parseInt(input.min || '0', 10), max = parseInt(input.max || '99', 10);
      var v = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty'), 10);
      input.value = Math.max(min, Math.min(max, v));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* Tri : envoi automatique */
  $$('[data-autosubmit]').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form.submit(); });
  });

  /* Panier : CGV + conversion Google Ads « Begin Checkout » */
  var checkout = $('[data-checkout]');
  var terms = $('[data-terms]');
  var checkoutSending = false;
  function fireBeginCheckout(done) {
    var ads = window.FE_GOOGLE_ADS || {};
    var finished = false;
    var finish = function () { if (finished) return; finished = true; done(); };
    if (typeof window.gtag !== 'function' || !ads.beginCheckout) {
      finish();
      return;
    }
    window.gtag('event', 'conversion', {
      send_to: ads.beginCheckout,
      value: Number(ads.cartValue) || 0,
      currency: ads.currency || 'EUR',
      event_callback: finish
    });
    setTimeout(finish, 1000);
  }
  if (checkout) {
    var err = $('[data-terms-error]');
    checkout.addEventListener('click', function (e) {
      if (terms && !terms.checked) {
        e.preventDefault();
        if (err) err.hidden = false;
        terms.focus();
        return;
      }
      if (checkoutSending) return;
      if (typeof window.gtag !== 'function') return;
      e.preventDefault();
      checkoutSending = true;
      fireBeginCheckout(function () {
        var form = checkout.form;
        if (!form) return;
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'checkout';
        hidden.value = '1';
        form.appendChild(hidden);
        form.submit();
      });
    });
    if (terms) {
      terms.addEventListener('change', function () { if (err && terms.checked) err.hidden = true; });
    }
  }

  /* ---------- Consentement cookies (CNIL) ---------- */
  var banner = $('#CookieConsent');
  var KEY = 'fe_cookie_consent_v1';
  var months = banner ? parseInt(banner.getAttribute('data-months') || '6', 10) : 6;

  function readChoice() {
    try {
      var c = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!c || !c.t) return null;
      if (Date.now() - c.t > months * 30 * 24 * 3600 * 1000) return null;
      return c;
    } catch (e) { return null; }
  }

  function withPrivacyApi(cb) {
    if (window.Shopify && window.Shopify.customerPrivacy) return cb(window.Shopify.customerPrivacy);
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error && window.Shopify.customerPrivacy) cb(window.Shopify.customerPrivacy);
      });
    }
  }

  function applyChoice(c) {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        ad_storage: c.marketing ? 'granted' : 'denied',
        ad_user_data: c.marketing ? 'granted' : 'denied',
        ad_personalization: c.marketing ? 'granted' : 'denied',
        analytics_storage: c.analytics ? 'granted' : 'denied'
      });
    }
    withPrivacyApi(function (api) {
      api.setTrackingConsent({
        analytics: !!c.analytics,
        marketing: !!c.marketing,
        preferences: !!c.preferences,
        sale_of_data: !!c.marketing
      }, function () {});
    });
  }

  function saveChoice(c) {
    c.t = Date.now();
    try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}
    applyChoice(c);
    hideBanner();
  }

  function showBanner(withPrefs) {
    if (!banner) return;
    var prefs = $('[data-cookie-prefs]', banner);
    var current = readChoice() || {};
    $$('input[name]', prefs).forEach(function (i) { i.checked = !!current[i.name]; });
    prefs.hidden = !withPrefs;
    $('[data-cookie="save"]', banner).hidden = !withPrefs;
    $('[data-cookie="custom"]', banner).hidden = !!withPrefs;
    banner.hidden = false;
  }
  function hideBanner() { if (banner) banner.hidden = true; }

  if (banner) {
    banner.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cookie]');
      if (!btn) return;
      var action = btn.getAttribute('data-cookie');
      if (action === 'accept') saveChoice({ analytics: true, marketing: true, preferences: true });
      if (action === 'reject') saveChoice({ analytics: false, marketing: false, preferences: false });
      if (action === 'custom') showBanner(true);
      if (action === 'save') {
        var c = {};
        $$('[data-cookie-prefs] input[name]', banner).forEach(function (i) { c[i.name] = i.checked; });
        saveChoice(c);
      }
    });
    var existing = readChoice();
    if (existing) applyChoice(existing); else showBanner(false);
  }
  $$('[data-cookie-open]').forEach(function (b) {
    b.addEventListener('click', function () { showBanner(true); });
  });
})();
